import { PureComponent } from 'preact-compat'
import { ModerationLabel } from '../interfaces'
import Title from './Title'
import { ContentType } from '@insided/shared/utils/contentType'
import ProductAreas from './ProductAreas'
import PublicTags from './PublicTags'
import ModeratorTags from './ModeratorTags'
import Options from './Options'
import LoadingMessage from './LoadingMessage'
import ModerationLabels from './ModerationLabels'
import { ConfigContext } from '../utils'
/* eslint-disable import/no-internal-modules */
import { ProductAreaType } from '@insided/deprecated-control/product-areas/ProductAreaSelect'
import Panel from '@insided/deprecated-control/panel'
import { ModulesContext } from '@insided/deprecated-utils/globals'

interface TopicDetailsProps {
  contentType: ContentType
  privateId: number
  onTitleChanged: (value: string) => void
  onProductAreasChanged: (newProductAreas: ProductAreaType[]) => void
  onPublicTagsChanged: (newTags: string[]) => void
  onModeratorTagsChanged: (newTags: string[]) => void
  onClosedChanged: (newValue: boolean) => void
  onModerationLabelChanged: (moderationLabel: ModerationLabel | null) => void
  title: string
  allProductAreas: ProductAreaType[]
  productAreas: ProductAreaType[]
  publicTags: string[]
  moderatorTags: string[]
  moderationLabels: ModerationLabel[]
  selectedModerationLabel: ModerationLabel | null
  closed: boolean
}

interface TopicDetailsState {
  isLoading: boolean | null
}

class TopicDetails extends PureComponent<TopicDetailsProps, TopicDetailsState> {
  constructor() {
    super()
    this.setState({ isLoading: null })
    this.setIsLoading = this.setIsLoading.bind(this)
  }

  setIsLoading (isLoading: boolean) {
    this.setState({ isLoading })
  }

  render () {
    const { contentType, privateId, onTitleChanged, title, allProductAreas, productAreas, onProductAreasChanged, publicTags, moderatorTags, moderationLabels, selectedModerationLabel, onPublicTagsChanged, onModeratorTagsChanged, onClosedChanged, onModerationLabelChanged, closed } = this.props
    const { isLoading } = this.state
    return (
      <ModulesContext.Consumer>
        {(modules) => {
          return (
            <ConfigContext.Consumer>
              {({ contentTypeConfig }) => {
              const showProductAreas = modules.includes('productAreas') && contentTypeConfig.productAreas && Boolean(allProductAreas.length)
              return (
                <Panel collapsible title='Details'>
                  <div id='topic-moderation--thread-options'>
                    <div className='panel-body' id='panelSettings'>
                      <div className='topic-info__details-items'>
                        <Title
                          contentType={contentType}
                          onTitleChanged={onTitleChanged}
                          setIsLoading={this.setIsLoading}
                          title={title}
                          privateId={privateId}
                        />
                        {showProductAreas && (
                          <ProductAreas
                            onProductAreasChanged={onProductAreasChanged}
                            setIsLoading={this.setIsLoading}
                            productAreas={productAreas}
                            contentType={contentType}
                            privateId={privateId}
                            allProductAreas={allProductAreas}
                          />
                        )}
                        <PublicTags
                          contentType={contentType}
                          onPublicTagsChanged={onPublicTagsChanged}
                          setIsLoading={this.setIsLoading}
                          publicTags={publicTags}
                          privateId={privateId}
                        />
                        <ModeratorTags
                          contentType={contentType}
                          onModeratorTagsChanged={onModeratorTagsChanged}
                          setIsLoading={this.setIsLoading}
                          moderatorTags={moderatorTags}
                          privateId={privateId}
                        />
                        <Options
                          onClosedChanged={onClosedChanged}
                          setIsLoading={this.setIsLoading}
                          closed={closed}
                          contentType={contentType}
                          privateId={privateId}
                        />
                        <div className='topic-info__details-item' />
                        {contentTypeConfig.moderationLabel &&
                          <ModerationLabels
                            onModerationLabelChanged={onModerationLabelChanged}
                            setIsLoading={this.setIsLoading}
                            selectedModerationLabel={selectedModerationLabel}
                            moderationLabels={moderationLabels}
                            contentType={contentType}
                            privateId={privateId}
                          />}
                      </div>
                    </div>
                    <LoadingMessage isLoading={isLoading} />
                  </div>
                </Panel>
              )
            }}
            </ConfigContext.Consumer>
          )
        }}
      </ModulesContext.Consumer>
    )
  }
}

export default TopicDetails
